<!-- page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-top fixtures-single">
        <div class="fixtures-top-detail-banner cf">
        	<div class="fixtures-top-detail-slider">
        		<div class="fixtures-top-detail-slider-box">
        			<div class="fixtures-top-detail-slider-box-left">
        				<div class="fixtures-top-detail-slider-box-left-text">
        					<p>{{matchesSingle?.first_name}}</p>
        				</div>
        				<div class="fixtures-top-detail-slider-box-left-image">
        					<img [src]="matchesSingle?.first_image" alt="Bitmap">
        				</div>
        			</div>
        			<div class="fixtures-top-detail-slider-box-center">
        				<div class="fixtures-top-detail-slider-box-center-inner">
	        				<h3>Home {{matchesSingle?.date_time | amDateFormat:'HH:mm'}}</h3>
	        				<p>{{matchesSingle?.date_time | amDateFormat:'ddd DD MMM'}}</p>
	        			</div>
        			</div>
        			<div class="fixtures-top-detail-slider-box-right">
        				<div class="fixtures-top-detail-slider-box-left-image">
        					<img [src]="matchesSingle?.second_image" alt="Bitmap">
        				</div>
        				<div class="fixtures-top-detail-slider-box-left-text">
        					<p>{{matchesSingle?.second_name}}</p>
        				</div>
        			</div>
        		</div>
        		<div class="fixtures-top-detail-slider-btn">
        			<a href="javascript:void(0);">Watch Highlight</a>
        		</div>
        	</div>
        </div>
        <div class="fixtures-center-detail-section cf">
        	<div class="container">
        		<div class="ashton-hero-top-news-single-about">
         	   <div class="red-titel">{{matchesSingle?.title}}</div>	
         	   <div class="ashton-hero-top-news-single-about-content" [innerHTML]="matchesSingle?.description">
         	   	
         	   </div>
         	</div>
        		
        	</div>
        </div>
      </div>
    </section><!-- page ends-->